import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { Table } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import CalendarComponent from "../../components/Calendar/CalendarComponent";
import * as Actions from "../../store/action/inspectionMission";
import { useDispatch, useSelector } from "react-redux";
import { fetchRepairers } from "../../store/action/repairer";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import formatDateToFrench from "../../utils/formatDateToFrench.js";
import getDateTime from "../../utils/getDateTime.js";
import { format, set } from "date-fns";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { Box, Grid } from "@mui/material";
import DatePicker from "react-multi-date-picker";
import "./Planning.css"
import InputIcon from "react-multi-date-picker/components/input_icon"
import DatePanel from "react-multi-date-picker/plugins/date_panel"
import weekends from "react-multi-date-picker/plugins/highlight_weekends"
import ErrorsAlert from "../../utils/errorsAlert";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "85vh",
  },
  tableHeadRows: {
    whiteSpace: "nowrap",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "18px",
    color: "rgba(181, 181, 195, 1)",
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    padding: "1%",
  },
  tableCellSmall: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "21px",
    color: "rgba(70, 78, 95, 1)",
    borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",
  },
  tableCellSmallCollapseHead: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "18px",
    color: "rgba(74, 75, 104, 1)",
  },
  tableCellSmallCollapse: {
    fontFamily: "Poppins",
    fontSize: "12px",
    lineHeight: "18px",
    fontWeight: 400,
    color: "rgba(70, 78, 95, 1)",
  },
  paper: {
    width: "100%",
    borderRadius: "11px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },
  tableWrapper: {
    padding: "40px",
  },
  dialogPaper: {
    width: "1300px",
    overflow: "visible",
    background: "rgb(243, 246, 249)",
    height: "rem",
    borderRadius: "11px",
    
  },
  dialogTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 15,
    color: "rgba(63, 66, 84, 1)",
    backgroundColor: "white",
    borderBottom: "1px solid #E5EAEE",
  },

  dialogContent: {
    overflowY: "auto",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  closeButton: {
    cursor: "pointer",
    color: "rgba(32, 18, 70, 1)",
    marginLeft: 1051,
  },
  titre: {
    fontFamily: "Poppins",
    fontSize: "13.8px",
    fontWeight: 600,
    lineHeight: "20.7px",
    color: "rgba(63, 66, 84, 1)",
  },
  titreLabel: {
    marginLeft: "10px",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  tablePagination: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  optionItem: {
    width: "150px",
    padding: theme.spacing(1),
    cursor: "pointer",
    backgroundColor: "white",
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  optionLabel: {
    width: "150px",
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  annulerStyle: {
    width: "62px",
    height: "26px",
    backgroundColor: "rgba(255, 229, 229, 1)",
    borderRadius: "5.38px",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    color: "rgba(255, 54, 54, 1)",
    border: 0,
  },
  ajouterStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    backgroundColor: "rgba(60, 101, 86, 1)",
    color: "rgba(255, 255, 255, 1)",
    borderRadius: "5.38px",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
  },
  CancelStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    color: "#464E5F",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
  },
  viewBtn: {
    width: "40px",
    height: "34px",
    borderRadius: "6px",
    backgroundColor: "rgba(240, 243, 199, 1)",
    border: 0,
    lineHeight: "18px",
    color: "rgba(187, 200, 8, 1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  titreLabelDialog: {
    marginLeft: "20px",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    color: "#464E5F",
    padding: "10px 0px ",
  },
  selectInputDialog: {
    marginLeft: "20px",
    border: "1px solid #DEDEDE",
    background: "rgba(255, 255, 255, 1)",
    width: "90%",
    height: "36px",
    borderRadius: 5,
    fontFamily: "Poppins",
    fontSize: "12px",
  },
  selectInput: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "180px",
    height: "34px",
    borderRadius: 5,
    marginLeft: "20px",
  },
  dateContainer: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    outline: "none",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 5,
    fontFamily: "Poppins",
    paddingLeft: "5px",
    marginLeft: "20px",
    width: "100%",
  },
}));
export default function Planning() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { inspectorData } = useSelector((state) => state.inspectorReducer);
  const { inspectorShiftTimeslotData } = useSelector(
    (state) => state.inspectorShiftTimeslotReducer
  );
  const { repairers } = useSelector((state) => state.repairers);
  const [open, setOpen] = useState(false);
  const hoursArray = [];
  const [hoursArray1, sethoursArray1] = useState([]);
  const [groupBy, setGroupBy] = useState("Garage");
  const [expertFilter, setExpertFilter] = useState("");
  const [garageFilter, setGarageFilter] = useState("");
  const [dateFilterValue, setDateFilterValue] = useState(
    format(new Date(), "dd/MM/yyyy")
  );
  const [dateFiltre, setDateFiltre] = useState([]);
  const today = new Date();
  const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);
  const tomorrowFormatted = format(tomorrow, "yyyy-MM-dd");
  const todayFormatted = format(today, "yyyy-MM-dd");
  const [formData, setFormData] = useState({
    associatedInspector: "",
    associatedRepairShop: "",
    date: "",
    startDate: "",
    endDate: "",
  });
  const [dates, setDates] = useState([]);
  const [errors, setErrors] = useState([]);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const handleClose = () => {
    setOpenErrorDialog(false);
    setErrors([]);
  };
  for (let hour = 8; hour <= 18; hour++) {
    for (let minute = 0; minute < 60; minute += 30) {
      hoursArray.push(
        `${hour.toString().padStart(2, "0")}:${minute
          .toString()
          .padStart(2, "0")}`
      );
    }
  }
  const getRest = (hoursArray, heure) => {
    let hoursArray1 = hoursArray.slice(hoursArray.indexOf(heure) + 1);
    sethoursArray1(hoursArray1);
  };
  const fetchAllData = async () => {
    try {
      await dispatch(Actions.getAllInspector());
      await dispatch(fetchRepairers());
      await dispatch(Actions.getAllInspectorShiftTimeslot());
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const groupeBy = (event, expertFilter, garageFilter, dateValue) => {
    setGroupBy(event);
    let groupedObjects;
    let dataObject = inspectorShiftTimeslotData;
    if (expertFilter != "") {
      dataObject = dataObject.filter(
        (data) => data.associatedInspector === expertFilter
      );
    }
    if (garageFilter != "") {
      dataObject = dataObject.filter(
        (data) => data.associatedRepairShop === garageFilter
      );
    }
    if (dateValue != "") {
      dataObject = dataObject.filter((data) => {
        const date = new Date(data?.date);
        return date.toLocaleDateString("fr-FR") === dateValue;
      });
    }
    if (event === "Garage") {
      groupedObjects = dataObject.reduce((acc, obj) => {
        const repairShopId = obj.repairShopDetails._id;
        if (!acc[repairShopId]) {
          acc[repairShopId] = {
            repairShopDetails: obj.repairShopDetails,
            shifts: [],
          };
        }
        acc[repairShopId].shifts.push(obj);
        return acc;
      }, {});
    } else {
      groupedObjects = dataObject.reduce((acc, obj) => {
        const inspectorId = obj.inspectorDetails._id;
        if (!acc[inspectorId]) {
          acc[inspectorId] = {
            inspectorDetails: obj.inspectorDetails,
            shifts: [],
          };
        }
        acc[inspectorId].shifts.push(obj);
        return acc;
      }, {});
    }
    //console.log("groupedObjects", groupedObjects);
    setDateFiltre(groupedObjects);
  };

  const getRepairerScope = (repairShopId) => {
    const selectedRepairer = repairers.find(
      (rep) => rep.associatedParty === repairShopId
    );
    if (!selectedRepairer) return [];

    return selectedRepairer.caracteristiques
      .filter((char) => char.key === "SCOPE")
      .map((char) => char.value);
  };

  const filteredInspectors = inspectorData.filter((inspector) => {
    const inspectorScopes = inspector.inspectorCaracteristiques
      .filter((char) => char.key === "SCOPE")
      .map((char) => char.value);

    return inspectorScopes.some((scope) =>
      getRepairerScope(formData.associatedRepairShop).includes(scope)
    );
  });

  const reset = () => {
    setFormData({
      associatedInspector: "",
      associatedRepairShop: "",
      date: "",
      startDate: "",
      endDate: "",
    });
    setOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    if (name === "startDate") {
      getRest(hoursArray, value);
    }
  };
  const validate = (formData) => {
    // const errors = [];
    if (!formData.associatedInspector) {
      errors.push("Veuillez sélectionner un inspecteur");
    }
    if (!formData.associatedRepairShop) {
      errors.push("Veuillez sélectionner un garage");
    }
    // if (!formData.date) {
    //   errors.push("Veuillez sélectionner une date");
    // }
    if (!formData.startDate) {
      errors.push("Veuillez sélectionner une heure de début");
    }
    if (!formData.endDate) {
      errors.push("Veuillez sélectionner une heure de fin");
    }
    return errors;
  };
  const handleSubmit = async () => {
    const errors = validate(formData);

    if (errors.length === 0) {
      const promises = dates.map(async (date) => {
        const formattedDate = new Date(date);
        const startDate = new Date(`${date}T${formData.startDate}:00`);
        const endDate = new Date(`${date}T${formData.endDate}:00`);
        const shiftData = {
          ...formData,
          date: formattedDate.toISOString(),
          startDate: startDate.toISOString(),
          endDate: endDate.toISOString(),
        };
        await dispatch(Actions.createInspectorShiftTimeslot(shiftData));
      });

      await Promise.all(promises);
      reset();
      fetchAllData();
    } else {
      setErrors(errors);
      setOpenErrorDialog(true);
    }
  };

  const setDateValue = (data) => {
    setDateFilterValue(data.toLocaleDateString("fr-FR"));
    groupeBy(
      groupBy,
      expertFilter,
      garageFilter,
      data.toLocaleDateString("fr-FR")
    );
  };

  useEffect(() => {
    fetchAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  
  useEffect(() => {
    groupeBy(groupBy, expertFilter, garageFilter, dateFilterValue);
  }, [inspectorShiftTimeslotData]);
  const filteredRepairers = repairers.filter((repairer) =>
    repairer.caracteristiques.some(
      (char) => char.key === "SCOPE" && char.value === "RGA"
    )
  );
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}></Paper>

      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "20px",
              marginBottom: "40px",
            }}
          >
            <div className={classes.titre} style={{ width: "10%" }}>
              Filtrer par
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "50%",
                justifyContent: "flex-start",
                whiteSpace: "nowrap",
              }}
            >
              <div className={classes.titreLabel}>
                Expert
                <select
                  className={classes.selectInput}
                  onChange={(e) => {
                    setExpertFilter(e.target.value);
                    groupeBy(
                      groupBy,
                      e.target.value,
                      garageFilter,
                      dateFilterValue
                    );
                  }}
                >
                  <option className={classes.optionItem} value="">
                    Sélectionnez une option
                  </option>
                  {inspectorData?.map((inspector, index) => (
                    <option
                      className={classes.optionItem}
                      value={inspector.associatedParty}
                    >
                      {inspector?.personDetails?.name}{" "}
                      {inspector?.personDetails?.lastName}
                    </option>
                  ))}
                </select>
              </div>
              <div className={classes.titreLabel}>
                Garage
                <select
                  className={classes.selectInput}
                  onChange={(e) => {
                    setGarageFilter(e.target.value);
                    groupeBy(
                      groupBy,
                      expertFilter,
                      e.target.value,
                      dateFilterValue
                    );
                  }}
                >
                  <option className={classes.optionItem} value="">
                    Sélectionnez une option
                  </option>

                  {filteredRepairers?.map((repairer, index) => (
                    <option
                      className={classes.optionItem}
                      value={repairer.associatedParty}
                    >
                      {repairer.organizationName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "40%",
                justifyContent: "flex-end",
              }}
            >
              <div className={classes.titre}>
                Grouper par
                <select
                  className={classes.selectInput}
                  onChange={(e) =>
                    groupeBy(
                      e.target.value,
                      expertFilter,
                      garageFilter,
                      dateFilterValue
                    )
                  }
                  value={groupBy}
                >
                  <option className={classes.optionItem} value={"Garage"}>
                    Garage
                  </option>
                  <option className={classes.optionItem} value={"Expert"}>
                    Expert
                  </option>
                </select>
              </div>
              <button
                className={classes.ajouterStyle}
                onClick={() => setOpen(true)}
              >
                Ajouter
              </button>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div
              style={{
                alignItems: "center",
                width: "75%",
                paddingRight: "20px",
              }}
            >
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="small"
              >
                <tr>
                  <TableCell
                    height={"43px"}
                    align="left"
                    className={classes.tableHeadRows}
                    style={{
                      borderTopLeftRadius: "6px",
                      borderBottomLeftRadius: "6px",
                    }}
                  >
                    Garage/Expert
                  </TableCell>
                  <TableCell
                    height={"43px"}
                    align="right"
                    className={classes.tableHeadRows}
                    style={{
                      borderTopRightRadius: "6px",
                      borderBottomRightRadius: "6px",
                    }}
                  >
                    Planning{" "}
                  </TableCell>
                </tr>
                <tr>
                  <TableCell colspan="2" height={"43px"} style={{ border: 0 }}>
                    <Accordion allowMultiple defaultIndex={[0]}>
                      {dateFiltre !== null &&
                      Object.keys(dateFiltre).length > 0 ? (
                        <>
                          {Object.keys(dateFiltre).map((data, index) => (
                            <AccordionItem key={index}>
                              <AccordionButton
                                style={{
                                  height: "47px",
                                  border: "none",
                                  background: "rgba(255, 255, 255, 1)",
                                  borderBottom:
                                    "1px solid rgba(224, 224, 224, 1)",
                                }}
                              >
                                <AccordionIcon
                                  size="30px"
                                  style={{
                                    backgroundColor: "rgba(240, 243, 199, 1)",
                                    width: "25px",
                                    height: "25px",
                                    borderRadius: "5px",
                                    color: "rgba(187, 200, 8, 1)",
                                  }}
                                />
                                <Box
                                  as="div"
                                  textAlign="left"
                                  marginLeft="20px"
                                  style={{
                                    color: "#BBC808",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    lineHeight: "21px",
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  {groupBy === "Garage"
                                    ? dateFiltre[data].repairShopDetails
                                        ?.organizationName
                                    : dateFiltre[data].inspectorDetails?.name +
                                      " " +
                                      dateFiltre[data].inspectorDetails
                                        ?.lastName}
                                </Box>
                              </AccordionButton>
                              <AccordionPanel
                                style={{
                                  background: "rgba(249, 249, 249, 1)",
                                  borderRadius: "11px",
                                }}
                              >
                                {dateFiltre[data].shifts.map((a, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      padding: "10px 3px",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      background: "rgba(249, 249, 249, 1)",
                                      borderBottom:
                                        "1px solid rgba(224, 224, 224, 1)",
                                      color: "#464E5F",
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      lineHeight: "21px",
                                      fontFamily: "Poppins",
                                    }}
                                  >
                                    {groupBy === "Garage" ? (
                                      <div style={{ width: "75%" }}>
                                        {a.inspectorDetails?.name +
                                          " " +
                                          a.inspectorDetails?.lastName}
                                      </div>
                                    ) : (
                                      <div style={{ width: "75%" }}>
                                        {a.repairShopDetails?.organizationName}
                                      </div>
                                    )}
                                    <div
                                      style={{
                                        width: "25%",
                                        textAlign: "right",
                                      }}
                                    >
                                      {formatDateToFrench(a.date)}{" "}
                                      <span
                                        style={{
                                          color: "#BBC808",
                                          fontWeight: 700,
                                        }}
                                      >
                                        ({getDateTime(a.startDate)} à{" "}
                                        {getDateTime(a.endDate)})
                                      </span>
                                    </div>
                                  </div>
                                ))}
                              </AccordionPanel>
                            </AccordionItem>
                          ))}
                        </>
                      ) : (
                        <>
                          <Box
                            style={{
                              fontFamily: "Poppins",
                              fontWeight: 400,
                              fontSize: 15,
                              lineHeight: "22.5px",
                              color: "rgba(70, 78, 95, 1)",
                              padding: "20px",
                            }}
                          >
                            Aucun expert planifié pour la journée du{" "}
                            {dateFilterValue}
                          </Box>
                        </>
                      )}
                    </Accordion>
                  </TableCell>
                </tr>
              </Table>
            </div>
            <div style={{ alignItems: "center", width: "20%" }}>
              <CalendarComponent setDateValue={setDateValue} />
            </div>
          </div>
        </div>
      </Paper>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        classes={{ paper: classes.dialogPaper }}
        maxWidth="sm"
      >
        <DialogTitle className={classes.dialogTitle}>Planification</DialogTitle>
        <DialogContent style={{ backgroundColor: "white", padding: "10px" }}>
          <div className={classes.titreLabelDialog}>Garage</div>
          <select
            className={classes.selectInputDialog}
            name="associatedRepairShop"
            value={formData.associatedRepairShop}
            onChange={handleChange}
          >
            <option className={classes.optionItem} value="">
              Sélectionnez une option
            </option>

            {filteredRepairers?.map((repairer, index) => (
              <option
                className={classes.optionItem}
                value={repairer.associatedParty}
              >
                {repairer.organizationName}
              </option>
            ))}
          </select>
          <div className={classes.titreLabelDialog}>Expert </div>
          <select
            className={classes.selectInputDialog}
            name="associatedInspector"
            value={formData.associatedInspector}
            onChange={handleChange}
          >
            <option className={classes.optionItem} value="">
              Sélectionnez une option
            </option>
            {filteredInspectors.map((inspector) => (
              <option
                className={classes.optionItem}
                key={inspector._id}
                value={inspector.associatedParty}
              >
                {inspector?.personDetails?.name}{" "}
                {inspector?.personDetails?.lastName}
              </option>
            ))}
          </select>

          <div className={classes.titreLabelDialog}>Date</div>
          <DatePicker
            multiple
            zIndex={9999}
            value={dates}
            weekStartDayIndex={1}
            plugins={[
              weekends(),
              <DatePanel sort="date" style={{
                
              }} />
            ]}
            render={<InputIcon  style={{
              border: "0.61px solid rgba(226, 217, 239, 1)",
              outline: "none",
              background: "rgba(255, 255, 255, 1)",
              borderRadius: 5,
              fontFamily: "Poppins",
              paddingLeft: "5px",
              height: "36px",
              marginLeft: "20px",
              width: "100%", 
            }}/>}
            onChange={(newDates) => {
              setDates(Array.isArray(newDates) ? [...newDates] : []);
            }}
            format="YYYY-MM-DD"
            minDate={new Date(new Date().getTime() - 3 * 60 * 60 * 1000)}
            className={classes?.dateContainer || ""}
            calendarPosition={"top-center"}
          />
   <div>
   {/* <input className={classes.selectInputDialog} onClick={() => setOpenc(true)} readOnly />
      <MultipleDatesPicker
        open={openc}
        dates={[]}
        minDate={new Date(new Date().getTime() - 3 * 60 * 60 * 1000)}
        onCancel={() => setOpenc(false)}
        onSubmit={dates => {
          setDates(dates);
          setOpenc(false);
        }}
      /> */}
    </div>
          <div className={classes.titreLabelDialog}>Heure début</div>
          <select
            className={classes.selectInputDialog}
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
          >
            <option className={classes.optionItem} value="">
              Sélectionnez une option
            </option>
            {hoursArray ? (
              hoursArray.map((item) => (
                <option key={item} value={item}>
                  {" "}
                  {item}{" "}
                </option>
              ))
            ) : (
              <option> </option>
            )}
          </select>
          <br />
          {formData.startDate ? (
            <>
              <div className={classes.titreLabelDialog}>Heure de fin</div>
              <select
                className={classes.selectInputDialog}
                name="endDate"
                value={formData.endDate}
                onChange={handleChange}
              >
                {hoursArray1 ? (
                  hoursArray1.map((item) => (
                    <option key={item} value={item}>
                      {" "}
                      {item}{" "}
                    </option>
                  ))
                ) : (
                  <option> </option>
                )}
              </select>
            </>
          ) : (
            <></>
          )}
        </DialogContent>
        <DialogActions>
          <button className={classes.CancelStyle} onClick={() => reset()}>
            Cancel
          </button>
          <button
            className={classes.ajouterStyle}
            onClick={() => handleSubmit(formData)}
          >
            Valider
          </button>
        </DialogActions>
      </Dialog>
      <ErrorsAlert
        open={openErrorDialog}
        errors={errors}
        handleClose={handleClose}
      />
    </div>
  );
}
